import React, {Component} from "react";
import {map, trim, identity, startsWith, replace} from "lodash";

class InlineLink extends Component {

  static defaultProps: any = {
    translate:identity,
    countFormatter:identity
  }

  constructor(props){
    super(props)
    this.onChange = this.onChange.bind(this)
  }

  onChange(e) {
    e.preventDefault();
    const { setItems } = this.props
    const key = e.target.dataset.value;
    setItems([key])
  }

  getSelectedValue(){
    const { selectedItems=[] } = this.props
    if (selectedItems.length === 0) return null
    return selectedItems[0]
  }

  render() {
    const { items, disabled, translate } = this.props
    const selected = this.getSelectedValue();
    let className = "sk-sort";
    let last;
    let options = {
      "price_desc": "price_asc",
      "price_asc": "price_desc",
    };

    if (disabled) {
      className += " sk-sort-disabled";
    }

    return (
      <div className={className}>
        {map(items, ({key, label, field, title, disabled, doc_count}, idx) => {
          let text = translate(label || title || key);
          let linkClass = "sk-sort-item";

          if (last && last === field) {
            return;
          }
          last = field;

          if (startsWith(selected, field)) {
            key = options[selected];
            linkClass += " is-active " + trim(replace(key, field, ''), '_');
          }

          return <a href="#" key={idx} className={linkClass} data-value={key} onClick={this.onChange} >{text}</a>
        })}
      </div>
    )
  }
}

export default InlineLink;


// WEBPACK FOOTER //
// ./src/InlineList.js